import * as types from "../../actions/categories/types";
import { changeItemPosition } from "../../utils/positioning";

const initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  list: [],
  page: 0,
  pageCount: 0,
  count: 0,
  isMoving: false,
  savingId: null,
  successId: null,
};

export default function categories(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CATEGORIES_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_CATEGORIES_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: true,
        list: action.categories,
        page: action.page,
        pageCount: action.pageCount,
        count: action.count,
      });
    }
    case types.FETCH_CATEGORIES_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }

    case types.POSITION_CATEGORY_REQUEST: {
      return Object.assign({}, state, {
        isMoving: true,
        savingId: state.list[action.sourceIndex].id,
        successId: null,
        list: changeItemPosition(
          state.list,
          action.sourceIndex,
          action.destinationIndex
        ),
      });
    }
    case types.POSITION_CATEGORY_FAILURE: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: null,
        list: changeItemPosition(
          state.list,
          action.destinationIndex,
          action.sourceIndex
        ),
      });
    }
    case types.POSITION_CATEGORY_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: state.savingId,
      });
    }
    case types.MOVE_CATEGORY_TO_TOP_REQUEST: {
      const item = state.list[action.sourceIndex];
      return Object.assign({}, state, {
        isMoving: true,
        savingId: item.id,
        successId: null,
        list:
          state.page === 1
            ? changeItemPosition(state.list, action.sourceIndex, 0)
            : state.list.filter(category => category.id !== item.id),
      });
    }
    case types.MOVE_CATEGORY_TO_TOP_FAILURE: {
      let newList;

      if (state.page === 1) {
        newList = changeItemPosition(state.list, 0, action.sourceIndex);
      } else {
        newList = [...state.list];
        newList.splice(action.sourceIndex, 0, action.item);
      }

      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: null,
        list: newList,
      });
    }
    case types.MOVE_CATEGORY_TO_TOP_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: state.savingId,
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/categories/index.js